/**
 * UserProfile Service
 * 
 * Handles all User Profile-related API operations
 * Uses the new apiClient with TypeScript generics
 */

import apiClient from "../api/apiClient";
import { MerchantCredential } from "../api/clientCredentials";

/**
 * User Prodile Service Class
 * Provides both instance and static methods
 */
export class UserProfileService {
    constructor() { }

    // ========================================================================
    // Instance Methods
    // ========================================================================

    public async getUserProfiles(emailId: string, environment: string, cursor: number = 0, limit: number = 10, searchTerm?: string): Promise<any> {
        if (!emailId) {
            throw new Error(`Parameter "emailID" not specified.`);
        }

        try {
            let query = `user-profile/merchants?email=${emailId}&limit=${limit}&cursor=${cursor}`;
            if (searchTerm && searchTerm.trim()) {
                query += `&searchTerm=${encodeURIComponent(searchTerm.trim())}`;
            }
            const result = await apiClient.get<any>(query);
            return result;
        } catch (error: any) {
            // Handle 404 as an empty result (user has no merchants)
            if (error?.code === "ResourceNotFound" || error?.status === 404) {
                return { data: [], next: null, prev: null };
            }
            throw new Error(`Unable to retrieve merchants for user "${emailId}". Error: ${error.message}`);
        }
    }



    // ========================================================================
    // Static Methods (for backward compatibility)
    // ========================================================================

    public static async getUserProfiles(emailId: string, environment: string, cursor: number = 0, limit: number = 10, searchTerm?: string): Promise<any> {
        return userProfileService.getUserProfiles(emailId, environment, cursor, limit, searchTerm);
    }

    
}

export const userProfileService = new UserProfileService();
export default userProfileService;
